import { useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys } from '../api/dashboard.api';

export function useLawyerDeadlines() {
  return useQuery({
    queryKey: dashboardQueryKeys.lawyerDeadlines(),
    queryFn: () => dashboardApi.getLawyerDeadlines(),
  });
}
